import * as React from "react";
import BackspaceIcon from "@mui/icons-material/Backspace";

export default function BackspaceButton(props) {
  const { show, onClick } = props;

  if (!show) {
    return <div></div>;
  }

  return (
    <div style={{ display: "block", marginTop: "auto", marginBottom: "auto" }}>
      <BackspaceIcon
        style={{
          fontSize: "6vh",
          marginLeft: "1.5vh"
        }}
        onClick={onClick}
      />
    </div>
  );
}
